import React from 'react'
import AppContext from 'AppContext'
import { env } from 'components/Helpers'

const IncompleteSignups = (props) => {
  const { operator: { id } } = React.useContext(AppContext)

  // We may have to wait for AppContext to be available
  if (!id) {
    return (
      <div className='index sales-promotions' />
    )
  }

  // Must leave empty h1 there for element below not to be cropped...
  return (
    <div className='index sales-promotions'>
      {/* eslint-disable-next-line */}
      <h1 />
      <cl-incomplete-signups
        mountpath={`/operators/${id}/memberships/incomplete-signups`}
        apihost={`https://memberships.${env()}.credlock.net/api`}
      />
    </div>
  )
}

export default IncompleteSignups
